// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"C4-z","dimensionLabel":"D4-z","styleChooserControlWrapper":"E4-z","styleChooserControl":"F4-z","disabled":"G4-z","giftCard":"H4-z","styleChooserText":"I4-z"};